import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { DiscrepanciesComponent } from './discrepancies.component';
import { AppConstants } from 'src/app/common/constants/app-constants';

const caseInsensitiveComparator = (valueA: string, valueB: string): number => {
  const a = (valueA ?? AppConstants.emptyString).trim().toLowerCase();
  const b = (valueB ?? AppConstants.emptyString).trim().toLowerCase();

  if (a === AppConstants.emptyString && b === AppConstants.emptyString) return 0;
  if (a === AppConstants.emptyString) return -1;
  if (b === AppConstants.emptyString) return 1;

  return a.localeCompare(b);
};

export const columnDefinitionForecastAgenda = (
  component: DiscrepanciesComponent
): ColDef[] => [
  {
    headerName: 'Patient',
    field: 'name',
    sortable: true,
    suppressMenu: true,
    comparator: caseInsensitiveComparator,
    cellRenderer: (params: ICellRendererParams) => {
        if (params.value) {
          return params.value;
        }

        return "—";
      }
  } as ColDef,
  {
    headerName: 'Date',
    field: 'agendaDate',
    sortable: true,
    suppressMenu: true,
    cellRenderer:  (params: ICellRendererParams) => {
        if (params.value) {
          return params.value;
        }

        return "—";
      }
  } as ColDef,
  {
    headerName: 'Forcast',
    field: 'forecastMinutes',
    sortable: true,
    suppressMenu: true,
    cellClass: "text-center",
    cellRenderer:  (params: ICellRendererParams) => {
        if (params.value) {
          return params.value;
        }

        return "—";
      }
  } as ColDef,
  {
    headerName: 'Agenda',
    field: 'agendaMinutes',
    sortable: true,
    suppressMenu: true,
    cellClass: "text-center",
    cellRenderer:  (params: ICellRendererParams) => {
        if (params.value) {
          return params.value;
        }

        return "—";
      }
  } as ColDef,
];

export const columnDefinitionForecast = (
    component: DiscrepanciesComponent
  ): ColDef[] => [
    {
      headerName: 'Patient',
      field: 'name',
      sortable: true,
      suppressMenu: true,
      comparator: caseInsensitiveComparator,
      cellRenderer: (params: ICellRendererParams) => {
          if (params.value) {
            return params.value;
          }
  
          return "—";
        }
    } as ColDef,
    {
      headerName: 'Date',
      field: 'agendaDate',
      sortable: true,
      suppressMenu: true,
      cellRenderer:  (params: ICellRendererParams) => {
          if (params.value) {
            return params.value;
          }
  
          return "—";
        }
    } as ColDef,
    {
      headerName: 'Forcast',
      field: 'forecastMinutes',
      sortable: true,
      suppressMenu: true,
      cellClass: "text-center",
      cellRenderer:  (params: ICellRendererParams) => {
          if (params.value) {
            return params.value;
          }
  
          return "—";
        }
    } as ColDef
  ];
  export const columnDefinitionNoTherapist = (
    component: DiscrepanciesComponent
  ): ColDef[] => [
    {
      headerName: 'Patient',
      field: 'name',
      sortable: true,
      suppressMenu: true,
      comparator: caseInsensitiveComparator,
      cellRenderer: (params: ICellRendererParams) => {
          if (params.value) {
            return params.value;
          }
  
          return "—";
        }
    } as ColDef,
    {
      headerName: 'Date',
      field: 'agendaDate',
      sortable: true,
      suppressMenu: true,
      cellRenderer:  (params: ICellRendererParams) => {
          if (params.value) {
            return params.value;
          }
  
          return "—";
        }
    } as ColDef,
    {
        headerName: 'Discipline',
        field: 'discipline',
        sortable: true,
        suppressMenu: true,
        cellClass: "text-center",
        cellRenderer:  (params: ICellRendererParams) => {
            if (params.value) {
              return params.value;
            }
    
            return "—";
          }
      } as ColDef
  ];